export const SET_AUTH = 'auth:setAuth'
export const SET_AUTH_USER = 'auth:setAuthUser'
export const SET_USER_ROLES = 'auth:setUserRoles'
export const SET_USER_SELECTED_ROLE = 'auth:setUserSelectedRole'
export const SET_USER_ROLE_PATHS = 'auth:setUserRolePaths'
export const SET_USER_ROLE_PERMISSIONS = 'auth:setUserRolePermissions'
export const CLEAR_DATA = 'auth:clearData'